import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { take } from "rxjs";
import { environment } from "../../../environments/environment";


@Injectable()
export class CompanyService {

  constructor(
    private readonly http: HttpClient,
  ) { }

  private readonly COMPANIES_API_URL = `${environment.API}/companies`;

  getCompany(companyId: string) {
    return this.http.get<Record<string, any>>(`${this.COMPANIES_API_URL}/${companyId}`).pipe(take(1));
  }
}
